(function ($) {
  DJ.addBehavior('linesTruncate', '.js-lines-truncate', {
    attach: function () {
      const tilesContainer = this;
      const tiles = Array.prototype.slice.call(
        tilesContainer.querySelectorAll('.tile')
      );

      if (!tiles) {
        return false;
      }

      function truncate(lines, textWrapEl, textHeight, textLineHeight) {
        const textWrapElement = textWrapEl;
        const isTruncate = textHeight / textLineHeight >= lines;
        if (isTruncate) {
          textWrapElement.classList.add('tile__text-block__content-truncated');
          textWrapElement.style.height = `${lines * textLineHeight}px`;
        } else if (!isTruncate) {
          textWrapElement.style.height = 'auto';
        }
      }

      tiles.forEach((tile) => {
        const textWrapEl = tile.querySelector('.tile__text-block-content');
        const tileNote = tile.querySelector('.tile__note-inner');

        if (tileNote) {
          const textLineHeight = parseInt(
            document.defaultView
              .getComputedStyle(tileNote, null)
              .getPropertyValue('line-height'),
            10
          );
          const afterElementHeight = parseInt(
            window
              .getComputedStyle(tileNote, ':after')
              .getPropertyValue('line-height'),
            10
          );

          const textHeight = tileNote.clientHeight - afterElementHeight;

          truncate(2, tileNote, textHeight, textLineHeight);
        }

        if (!textWrapEl) {
          return false;
        }

        const textLineHeight = parseInt(
          document.defaultView
            .getComputedStyle(textWrapEl, null)
            .getPropertyValue('line-height'),
          10
        );
        const afterElementHeight = parseInt(
          window
            .getComputedStyle(textWrapEl, ':after')
            .getPropertyValue('line-height'),
          10
        );

        const textHeight = textWrapEl.clientHeight - afterElementHeight;
        const bannersNote = tile.querySelector('.tile__banners-note');
        const banners = Array.prototype.slice.call(
          tile.querySelectorAll('.tile__banners-banner')
        );

        if (banners.length === 1) {
          tile.querySelector('.tile__banners').classList.add('tile__banners-1');
          truncate(9, textWrapEl, textHeight, textLineHeight);
        }

        if (banners.length === 2) {
          truncate(7, textWrapEl, textHeight, textLineHeight);
        }

        if (banners.length >= 3) {
          tile.querySelector('.tile__banners').classList.add('tile__banners-3');
          truncate(5, textWrapEl, textHeight, textLineHeight);
        }

        if (banners.length > 2) {
          banners.map((banner, index) => {
            if (index > 2) {
              banner.remove();
            }
            return true;
          });
        }

        return true;
      });

      return true;
    },
  });
})(jQuery);
